import { ComponentType, lazy } from 'react';
import { hardReloadOnChunkError, isChunkLoadError } from './chunkLoadRecovery';

const LAZY_RETRY_KEY = 'lazy_chunk_retry';

/** React.lazy 라우트 chunk 404 시 1회 강제 새로고침 */
export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(async () => {
    try {
      const module = await factory();
      sessionStorage.removeItem(LAZY_RETRY_KEY);
      return module;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      if (!sessionStorage.getItem(LAZY_RETRY_KEY) && isChunkLoadError(message)) {
        sessionStorage.setItem(LAZY_RETRY_KEY, '1');
        hardReloadOnChunkError();
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
